import { forwardRef } from 'react'
import { createPortal } from 'react-dom'

const Portal = ({ children }) => {
  return typeof document === 'object'
    ? createPortal(children, document.body)
    : null
}

const AgGridTooltip = forwardRef(({ ...props }, ref) => {
  return (
    <Portal>
      <div
        {...props}
        ref={ref}
        className="opacity-1 absolute z-40 -mt-[6px] rounded-[4px] bg-dark-charcoal px-[6px] py-[2px] text-[12px] text-white transition-opacity"
      />
    </Portal>
  )
})

export default AgGridTooltip
